export default __webpack_public_path__ + "static/media/Xoso.e0c5252b.png";